import { render, staticRenderFns } from "./MappingColumn.vue?vue&type=template&id=579e1405"
import script from "./MappingColumn.vue?vue&type=script&lang=js"
export * from "./MappingColumn.vue?vue&type=script&lang=js"
import style0 from "./MappingColumn.vue?vue&type=style&index=0&id=579e1405&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports